/**
 * Build-time switches for features that are finished but not yet turned on.
 *
 * These are plain constants, not remote config: they exist to keep unfinished-in-production
 * surfaces out of the UI without deleting working code, and they are flipped in a commit.
 *
 * Mirrors `mobile/constants/features.ts`. A feature visible on one client and hidden on the other
 * is worse than one hidden on both, so flip the two together.
 */

/**
 * SMS messaging — the Messaging nav item and every `/messaging` route.
 *
 * OFF everywhere, QA and local dev included. The feature is built and works; it is not yet meant
 * to be in front of coaches.
 *
 * This is a *build* gate that sits in front of the existing per-organization one. `messagingEnabled`
 * on the profile says whether an organization is paying for messaging; this says whether anyone sees
 * the feature at all. Both have to pass, and this one is checked first.
 *
 * Deliberately a plain `false` rather than `import.meta.env.VITE_ENVIRONMENT !== 'production'`:
 * web has no environment-name variable at all, and the only automated web deploy is QA
 * (`deploy-web.yml`, on push to `dev`). A flag phrased as "on outside production" would therefore
 * be on in every build that exists today, which is the opposite of the intent.
 *
 * Flip to `true` to expose it.
 */
export const MESSAGING_ENABLED = false;
